import {CounterElementComponent} from './components/counter-element/counter-element.component';
import {ObjectToArrayPipe} from './pipes/object-to-array.pipe';
import {SelectionListComponent} from './components/selection-list/selection-list.component';
import {ListItemComponent} from './components/selection-list/list-item/list-item.component';
import {EditableParameterComponent} from './components/editable-parameter/editable-parameter.component';
import {InvalidTooltipComponent} from './components/invalid-tooltip/invalid-tooltip.component';
import {SafePipe} from './pipes/safe.pipe';
import {TooltipDirective} from './directives/tooltips/tooltip.directive';
import {PluckPipe} from './pipes/pluck.pipe';
import {TransformObjectPipe} from './pipes/transform-object.pipe';
import {WorkflowBarComponent} from './components/workflow-bar/workflow-bar.component';
import {CustomWorkflowBarComponent} from './components/custom-workflow-bar/custom-workflow-bar.component';
import {WorkflowStepComponent} from './components/workflow-bar/workflow-step/workflow-step.component';
import {WorkflowBarService} from './components/workflow-bar/services/workflow-bar.service';
import {InterpolatorDirective} from './directives/interpolator/interpolator.directive';
import {InterpolateService} from './services/interpolate.service';
import {SAutocompleteWithChips} from './components/s-auto-complete/s-auto-complete.component';
import {FilterPipe} from './pipes/filter.pipe';
import {ToggleSwitchComponent} from './components/toggle-switch/toggle-switch.component';
import {WorkflowBarActionsCreatorService} from './components/workflow-bar/services/workflow-bar-actions-creator.service';
import {HighlightPipe} from './pipes/highlight.pipe';
import {SearchFieldComponent} from './components/search-field/search-field.component';
import {EllipsisDirective} from './directives/ellipsis/ellipsis.directive';
import {ReadMoreDirective} from './directives/read-more/read-more.directive';
import {BirthDateYearsPipe} from './pipes/birth-date-years.pipe';
import {FileUploadService} from './services/file-upload-service';
import {StoreActionCreatorService} from './services/store-action-creator.service';
import {ButtonComponent} from './components/button/button.component';
import {GenericContextMenuComponent} from './components/context-menu/generic-context-menu/generic-context-menu.component';
import {LabelsColorMenuComponent} from './components/context-menu/labels-color-menu/labels-color-menu.component';
import {HistoryTableItemComponent} from './components/history/history-table/history-table-item/history-table-item.component';
import {InfoLinesComponent} from './components/info-lines/info-lines.component';
import {InfoBoxComponent} from './components/info-box/info-box.component';
import {UICustomizationService} from './services/ui-customization.service';
import {UICustomizationDirective} from './directives/ui-customization/ui-customization.directive';
import {ColorTextComponent} from './components/color-text/color-text.component';
import {ColorBoxComponent} from './components/color-box/color-box.component';
import {OutsideClickDirective} from './directives/click-outside/outside-click.directive';
import {IndicatorIconComponent} from './components/indicator-icon/indicator-icon.component';
import {DynamicallyAddComponentService} from '@ispm/shared/services/dynamically-add-component.service';
import {TemplateParserComponent} from './components/workflow-bar/template-parser/template-parser.component';
import {FormItemLabelComponent} from './components/form-item-label/form-item-label.component';
import {SplitButtonService} from './services/split-button.service';
import {PermissionSchemaRestrictComponent} from './directives/permission-schema/permission-schema-restrict.component';
import {TextualContentComponent} from '@ispm/shared/components/textual-content/textual-content.component';
import {AutomationLocatorPipe} from '@ispm/shared/pipes/automation-locator.pipe';
import {ProgressionService} from '@ispm/shared/services/progression.service';
import {EntityTreeService} from '@ispm/shared/services/entity-tree.service';
import {GroupingService} from '@ispm/shared/services/grouping.service';
import {OnInitDirective} from '@ispm/shared/directives/on-init/on-init.directive';
import {GroupingAndOrderingService} from '@ispm/shared/services/grouping-and-ordering.service';
import {BlurItemService} from '@ispm/shared/services/blur-item.service';
import {HyphensDirective} from '@ispm/shared/directives/hyphens/hyphens.directive';
import {EndpointService} from '@ispm/shared/services/endpoint.service';
import {NotificationStoreHandler} from '@ispm/shared/notification/service/notification-store-handler';
import {TestMetaDataStoreHandler} from '@ispm/shared/services/test-meta-data-store-handler';
import {FormDataSubstitutionService} from '@ispm/shared/services/form-data-substitution.service';
import {StopWorkflowComponent} from '@ispm/shared/components/stop-workflow/stop-workflow.component';
import {TranslationPipe} from '@ispm/shared/pipes/string-translate.pipe';
import {SessionStorageService} from '@ispm/shared/services/session-storage.service';
import {AdaptiveFilterService} from '@ispm/shared/services/adaptive-filter.service';
import {DataMigrationService} from '@ispm/shared/services/data-migration.service';
import {RemoveHtmlTagsPipe} from '@ispm/shared/pipes/remove-html-tags.pipe';
import {GenericPanelComponent} from "@ispm/layout/components/panel/generic-panel/generic-panel.component";
import {PanelsService} from "@ispm/layout/services/panels.service";
import {ConditionService} from '@ispm/shared/services/condition.service';
import {RichEditBoxComponent} from "@ispm/shared/components/rich-edit-box/rich-edit-box.component";
import {RetriggerUserActivationService} from "@ispm/shared/services/retrigger-user-activation.service";
import { AdditionalConfigurationService } from '@ispm/shared/services/additionalConfiguration.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { NotificationMessageComponent } from '@ispm/core/components/customise-notification/notification-message.component';
import {JsonTreeViewerComponent} from "@ispm/shared/components/json-tree-viewer/json-tree-viewer.component";
import { NotesSidePanelActorfilterPipe } from '@ispm/shared/pipes/notes-side-panel-actorfilter.pipe';
import {MultiHighlightPipe} from "@ispm/shared/pipes/multiHighlight.pipe";
import {ManageTagsComponent} from '@ispm/shared/components/manage-tags/manage-tags.component';
import {ManageTagsService} from '@ispm/shared/services/manage-tags.service';

export const SharedComponents = [
  CounterElementComponent,
  SelectionListComponent,
  ListItemComponent,
  TooltipDirective,
  EditableParameterComponent,
  InvalidTooltipComponent,
  WorkflowBarComponent,
  WorkflowStepComponent,
  InterpolatorDirective,
  SAutocompleteWithChips,
  ToggleSwitchComponent,
  SearchFieldComponent,
  EllipsisDirective,
  HyphensDirective,
  ReadMoreDirective,
  UICustomizationDirective,
  OutsideClickDirective,
  ButtonComponent,
  GenericContextMenuComponent,
  LabelsColorMenuComponent,
  HistoryTableItemComponent,
  InfoLinesComponent,
  InfoBoxComponent,
  ColorTextComponent,
  ColorBoxComponent,
  IndicatorIconComponent,
  TemplateParserComponent,
  TextualContentComponent,
  FormItemLabelComponent,
  PermissionSchemaRestrictComponent,
  OnInitDirective,
  StopWorkflowComponent,
  GenericPanelComponent,
  RichEditBoxComponent,
  CustomWorkflowBarComponent,
  RichEditBoxComponent,
  NotificationMessageComponent,
  RichEditBoxComponent,
  CustomWorkflowBarComponent,
  JsonTreeViewerComponent,
  ManageTagsComponent
];

export const SharedPipes = [
  ObjectToArrayPipe,
  SafePipe,
  PluckPipe,
  TransformObjectPipe,
  FilterPipe,
  HighlightPipe,
  BirthDateYearsPipe,
  AutomationLocatorPipe,
  TranslationPipe,
  RemoveHtmlTagsPipe,
  NotesSidePanelActorfilterPipe,
  MultiHighlightPipe
];

export const SharedServices = [
  WorkflowBarService,
  InterpolateService,
  WorkflowBarActionsCreatorService,
  FileUploadService,
  StoreActionCreatorService,
  UICustomizationService,
  SplitButtonService,
  DynamicallyAddComponentService,
  ProgressionService,
  ConditionService,
  EntityTreeService,
  BlurItemService,
  GroupingService,
  EndpointService,
  GroupingAndOrderingService,
  NotificationStoreHandler,
  TestMetaDataStoreHandler,
  FormDataSubstitutionService,
  PanelsService,
  FormDataSubstitutionService,
  SessionStorageService,
  AdaptiveFilterService,
  DataMigrationService,
  RetriggerUserActivationService,
  AdditionalConfigurationService,
  NotificationMessageService,
  ManageTagsService
];
